export class FindAllProjectMembers {
  public static readonly type = '[User/Projects] FindAllProjects';

  constructor(
    public readonly searchTerm?: string,
    public readonly pageNumber?: number,
  ) {}
}
